import type { StateType } from '../../lib/types/state-type';

export function setEnvironment(state: StateType, parameters: unknown[]): StateType {
  const environment = parameters[0] as string;
  return { ...state, environment: environment };
}
